import actionTypes from './actionTypes';
const INITIAL_STATE = {
  rolesLoading: false,
  rolesFailed: false,
  rolesError: false,
  rolesMessage: null,
  roles: {},
  rolesList: []

};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ROLES_LOADING:
      return {
        ...state,
        rolesLoading: true,
        rolesFailed: false,
        rolesError: false,
        rolesMessage: null
      };

    case actionTypes.FETCH_ROLES_SUCCESS:
      return {
        ...state,
        roles: { ...action.payload },
        rolesList: [...action.payload.roles],
        rolesLoading: false,
        rolesFailed: false,
        rolesError: false,
        rolesMessage: null
      };
    case actionTypes.FETCH_ROLES_FAILED:
      return {
        ...state,
        rolesLoading: false,
        rolesFailed: true,
        rolesError: false,
        rolesMessage: message
      }
    case actionTypes.FETCH_ROLES_REJECT:
      return {
        ...state,
        rolesLoading: false,
        rolesFailed: false,
        rolesError: true,
        rolesMessage: null
      }

    default:
      return state;
  }
};